import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
export default {
  name: "PageTitle.vue",
  data: function data() {
    return {};
  },
  computed: _objectSpread({}, mapGetters({
    currentProvider: "profile/currentProvider"
  })),
  methods: {
    onClickButton: function onClickButton() {
      this.$emit("onClickButton");
    }
  },
  props: {
    heading: {
      type: String,
      required: true
    },
    subHeading: {
      type: String,
      required: true
    },
    buttonTitle: {
      type: String,
      required: false
    }
  }
};